import { Box, Spinner, Text } from '@chakra-ui/react';
import React from 'react';
import { Result } from '../interfaces/components';
import SearchResult from './search/SearchResult';
import { AppStoreState, useAppStore } from '../store';
import { Image } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

interface ListPropsType {
  input: string;
}

function List(props: ListPropsType) {
  console.log('props', props);
  const navigate = useNavigate();
  const setProjId = useAppStore((state: AppStoreState) => state.setProjId);
  const renderSearchResults = useAppStore((state: AppStoreState) => state.renderSearchResults);
  const searchResults = useAppStore((state: AppStoreState) => state.searchResults);
  const loading = useAppStore((state: AppStoreState) => state.loading);

  const splitText = (text: string) => {
    const words = text.split(' ');
    const lastWord = words.pop();
    const firstPart = words.join(' ');
    return { firstPart, lastWord };
  };

  const onListItemClick = (item: Result) => {
    setProjId(item?.id);
    navigate(`/project/${item?.id}`);
  };

  return (
    <>
      {renderSearchResults ? (
        <SearchResult searchResults={searchResults} />
      ) : loading ? (
        <Box marginTop="24px">
          <Spinner />
        </Box>
      ) : (
        <Box width="100%" display="flex" flexDirection="column">
          <Box marginTop="16px" padding="16px" borderRadius="18px" background="#FFF" width="100%">
            {searchResults &&
              searchResults?.results?.length > 0 &&
              searchResults?.results?.map((item: Result) => {
                const { firstPart, lastWord } = splitText(item.name);
                return (
                  <Box
                    key={item.id}
                    padding="15px 8px"
                    display="flex"
                    gap="10px"
                    cursor="pointer"
                    alignItems="center"
                    onClick={() => onListItemClick(item)}
                  >
                    <Box>
                      <Image src={item.logo} alt="Logo" width="15px" height="15px" referrerPolicy="no-referrer" />
                    </Box>
                    <Text color="#000" fontSize="14px" fontWeight="500" lineHeight="normal">
                      {firstPart}{' '}
                      <Text as="span" fontSize="14px" fontWeight="700" color="#000">
                        {lastWord}
                      </Text>
                    </Text>
                  </Box>
                );
              })}
          </Box>
        </Box>
      )}
    </>
  );
}

export default List;
